/* custom-facets-toggle.js — "Filter +" toggle for the horizontal facet bar on
   the collection and search templates. Loaded by sections/main-collection.liquid
   and sections/custom-search-header.liquid. */
/* The bar hides its filter pills until a real "Filter +" button is pressed
   (the theme's label was a non-interactive ::before). State persists for the
   session and the bar opens itself whenever a filter is already applied. The
   button is re-inserted after Horizon re-renders the facets. */
(() => {
  const KEY = 'custom-facets-open';
  const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

  const setOpen = (bar, open) => {
    bar.classList.toggle('is-filters-open', open);
    const btn = bar.querySelector('.custom-facets-toggle');
    if (btn) btn.setAttribute('aria-expanded', String(open));
    try { sessionStorage.setItem(KEY, open ? '1' : '0'); } catch (e) {}
  };

  const mount = (bar) => {
    const wrapper = bar.querySelector('.facets__filters-wrapper');
    if (!wrapper || wrapper.querySelector('.custom-facets-toggle')) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'custom-facets-toggle';
    btn.innerHTML = '<span>Filter</span><span class="custom-facets-toggle__sign" aria-hidden="true"></span>';
    btn.addEventListener('click', () => setOpen(bar, !bar.classList.contains('is-filters-open')));
    wrapper.prepend(btn);

    let open = false;
    try { open = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (/[?&]filter\./.test(window.location.search)) open = true;
    setOpen(bar, open && isDesktop());
  };

  const scan = () => {
    document.querySelectorAll('body:is([data-template="collection"], [data-template="search"]) .facets--horizontal').forEach(mount);
  };

  document.addEventListener('DOMContentLoaded', scan, { once: true });
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
